<div class="loading-overlay" *ngIf="isLoading">
  <mat-spinner></mat-spinner>
</div>
